import { beginMessage } from '../message';
import { MessageTag } from '../messageTags';
import type { BinaryReader } from '../BinaryReader';
import { decodeProfileModel, writeProfileModel, type ProfileModel } from '../models/profileModel';

/**
 * Profile + avatar codec. Only GetProfile(16) returns a typed (ProfileModel) S2C response;
 * SaveProfile/ChangePassword/ChangePin/SaveAvatar acknowledge via a SendMessage(0) text toast.
 */

/** C2S GetProfile(16): empty body. */
export function encodeGetProfile(): Uint8Array {
  return beginMessage(MessageTag.GetProfile).toUint8Array();
}

/** S2C GetProfile(16): a ProfileModel (16 elements). */
export function decodeProfile(r: BinaryReader): ProfileModel {
  return decodeProfileModel(r);
}

/** C2S SaveProfile(63): a ProfileModel built from the editable bank fields. */
export function encodeSaveProfile(profile: ProfileModel): Uint8Array {
  const w = beginMessage(MessageTag.SaveProfile);
  writeProfileModel(w, profile);
  return w.toUint8Array();
}

/** C2S ChangePassword(17): oldPassword then newPassword (plaintext; server hashes). */
export function encodeChangePassword(oldPassword: string, newPassword: string): Uint8Array {
  return beginMessage(MessageTag.ChangePassword).putString(oldPassword).putString(newPassword).toUint8Array();
}

/** C2S ChangePin(10): the new PIN string. */
export function encodeChangePin(newPin: string): Uint8Array {
  return beginMessage(MessageTag.ChangePin).putString(newPin).toUint8Array();
}

/** C2S SaveAvatar(15): the selected avatar index as a 4-byte int. */
export function encodeSaveAvatar(avatar: number): Uint8Array {
  return beginMessage(MessageTag.SaveAvatar).putInt(avatar).toUint8Array();
}
